<template>
  <div>
    <div class="ui segment">
      <a class="ui ribbon label">
        <h1>Measurement</h1>
      </a>
      <div class="ui stretched two column grid">
        <div class="sixteen wide column">
          <observed-property-info-panel-component :observationsDetail="observationsDetail"></observed-property-info-panel-component>
        </div>
        <div class="column">
          <!-- <observation-temporal-extent-info-panel-component :temporalExtent="observationsDetail[0].observation.temporalExtent"></observation-temporal-extent-info-panel-component> -->
          <sensors-info-panel-component v-if="isProcedureNull" :observationsDetail="observationsDetail"></sensors-info-panel-component>
        </div>
        <div class="column">
          <!-- <data-access-info-panel-component :result="observationsDetail[0].observation.result" ></data-access-info-panel-component> -->
          <observation-location-info-panel-component
            :featureOfInterest="observationsDetail[0].observation.featureOfInterest"
          ></observation-location-info-panel-component>
        </div>
      </div>
    </div>
    <div class="ui segment">
      <a class="ui ribbon label">
        <h1>Dataset</h1>
      </a>
      <div class="ui stretched two column grid">
        <div class="column">
          <dataset-identification-info-panel-component :dataset="observationsDetail[0].dataset"></dataset-identification-info-panel-component>
          <contacts-info-panel-component
            :contacts="observationsDetail[0].dataset.metadata.contacts"
          ></contacts-info-panel-component>
          <dateset-temporal-extent-info-panel-component
            :temporalExtent="observationsDetail[0].dataset.metadata.temporalExtent"
          ></dateset-temporal-extent-info-panel-component>
          <dataset-spatial-extent-info-panel-component
            :spatialExtent="observationsDetail[0].dataset.metadata.spatialExtent"
          ></dataset-spatial-extent-info-panel-component>
        </div>
        <div class="column">
          <data-constraint-info-panel-component
            :dataConstraint="observationsDetail[0].dataset.metadata.dataConstraint"
          ></data-constraint-info-panel-component>
          <geology-climate-info-panel-component
            :geologies="observationsDetail[0].dataset.metadata.portalSearchCriteria.geologies"
            :climates="observationsDetail[0].dataset.metadata.portalSearchCriteria.climates"
          ></geology-climate-info-panel-component>
          <online-resource-info-panel-component
            :onlineResource="observationsDetail[0].dataset.metadata.onlineResource"
          ></online-resource-info-panel-component>
        </div>
      </div>
    </div>
    <div class="ui segment">
      <a class="ui ribbon label">
        <h1>Producer</h1>
      </a>
      <div class="ui stretched two column grid">
        <div class="column">
          <producer-identification-info-panel-component :producer="observationsDetail[0].producer"></producer-identification-info-panel-component>
          <producer-contacts-info-panel-component :producer="observationsDetail[0].producer"></producer-contacts-info-panel-component>
          <producer-online-resource-info-panel-component :producer="observationsDetail[0].producer"></producer-online-resource-info-panel-component>
        </div>
        <div class="column">
          <producer-fundings-info-panel-component
            :fundings="observationsDetail[0].producer.fundings"
          ></producer-fundings-info-panel-component>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
</style>

<script>
import observedPropertyInfoPanelComponent from "./observed-property-info-panel-component.vue";
import sensorsInfoPanelComponent from "./sensors-info-panel-component.vue";
import datasetIdentificationInfoPanelComponent from "./dataset-identification-info-panel-component.vue";
import dataConstraintInfoPanelComponent from "./data-constraint-info-panel-component.vue";
import contactsInfoPanelComponent from "./contacts-info-panel-component.vue";
import onlineResourceInfoPanelComponent from "./online-resource-info-panel-component.vue";
import producerIdentificationInfoPanelComponent from "./producer-identification-info-panel-component.vue";
import producerFundingsInfoPanelComponent from "./producer-fundings-info-panel-component.vue";
import observationLocationInfoPanelComponent from "./observation-location-info-panel-component.vue";
import dataProcessingInfoPanelComponent from "./data-processing-info-panel-component.vue";
import producerContactsInfoPanelComponent from "./producer-contacts-info-panel.vue";
import producerOnlineResourceInfoPanelComponent from "./producer-online-resource-info-panel-component.vue";
import geologyClimateInfoPanelComponent from "./geology-climate-info-panel-component.vue";
import datesetTemporalExtentInfoPanelComponent from "./dataset-temporal-extent-info-panel-component.vue";
import datasetSpatialExtentInfoPanelComponent from "./dataset-spatial-extent-info-panel-component.vue";

/**
 * Component composed of sub-component displaying the different information about one theia/OZCAR variable at one location
 * Several producer variables can be linked to the same OZCAR/Theia variable. Hence, informations about all thos producer variables are diplayed 
 */
export default {
  props: ["observationsDetail"],
  components: {
    observedPropertyInfoPanelComponent,
    sensorsInfoPanelComponent,
    datasetIdentificationInfoPanelComponent,
    dataConstraintInfoPanelComponent,
    contactsInfoPanelComponent,
    onlineResourceInfoPanelComponent,
    producerIdentificationInfoPanelComponent,
    producerFundingsInfoPanelComponent,
    observationLocationInfoPanelComponent,
    dataProcessingInfoPanelComponent,
    producerContactsInfoPanelComponent,
    producerOnlineResourceInfoPanelComponent,
    geologyClimateInfoPanelComponent,
    datesetTemporalExtentInfoPanelComponent,
    datasetSpatialExtentInfoPanelComponent
  },
  methods: {
		/**
		 * Method to check if Procedure object of the difference producer observation are null.
		 * If at least one procedure object of one observation is not null, the procedure
		 */
    isProcedureNull() {
      let isNull = true;
      this.observationsDetail.forEach(item => {
        isNull = isNull && item.observation.procedure == null;
      });
    }
  }
};
</script>
